import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.name";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
import FunctionTerm from '../components/FunctionTerm';
import ParamsTable from '../components/ParamsTable';
import ReturnItem from '../components/ReturnItem';
import ExampleItems from '../components/ExampleItems';
import NormalList from '../components/NormalList';

var FunctionItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FunctionItem, _React$Component);

  function FunctionItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FunctionItem.prototype;

  _proto.render = function render() {
    // eslint-disable-line complexity
    var data = this.props.data;
    var type = data.type,
        pid = data.pid,
        override = data.override,
        deprecated = data.deprecated,
        name = data.name,
        description = data.description,
        codeInfo = data.codeInfo,
        examples = data.examples,
        sees = data.sees,
        todos = data.todos,
        params = data.params,
        returns = data.returns;
    var popItems = [sees.slice(), todos.slice(), params.slice(), returns.slice()];
    popItems.forEach(function (items) {
      if (items.length) {
        items.pop(); // remove default item
      }
    });
    return React.createElement("div", {
      id: pid,
      className: "definition-list"
    }, React.createElement("dl", null, React.createElement("dt", {
      className: "subsection-term"
    }, React.createElement(FunctionTerm, {
      deprecated: deprecated,
      override: override,
      name: name,
      codeInfo: codeInfo
    })), React.createElement("dd", {
      className: "subsection-description"
    }, React.createElement("p", {
      className: "description",
      dangerouslySetInnerHTML: {
        __html: description
      }
    }), popItems[0].length ? React.createElement(NormalList, {
      title: 'SEES',
      items: popItems[0]
    }) : null, popItems[1].length ? React.createElement(NormalList, {
      title: 'TODOS',
      items: popItems[1]
    }) : null, React.createElement(ParamsTable, {
      properties: popItems[2],
      isPropertyTitle: type === 'event'
    }), popItems[3].length ? React.createElement(ReturnItem, {
      data: popItems[3][0]
    }) : null, examples.length ? React.createElement(ExampleItems, {
      items: examples
    }) : null)));
  };

  return FunctionItem;
}(React.Component);

export default FunctionItem;